import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EvaluationDestination, EvaluationVehicle } from '@app-model/evaluation';
import { EvaluationService, UpdateEvalPriceRequest } from '@app-services/evaluation.service';
import { toPriceCentValue } from '@app-utils/eval-price.utils';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/internal/operators/finalize';

@Component({
  selector: 'app-dialog-confirm-pricing',
  templateUrl: './dialog-confirm-pricing.component.html',
  styleUrls: ['./dialog-confirm-pricing.component.scss']
})
export class DialogConfirmPricingComponent implements OnInit {
  
  form: FormGroup;
  vehicle: EvaluationVehicle;
  loadingUpdatePricing: boolean;
  
  constructor(
    @Inject(MAT_DIALOG_DATA)
    data: {
      vehicle: EvaluationVehicle;
    },
    private fb: FormBuilder,
    private evaluationService: EvaluationService,
    private toastrService: ToastrService,
    private dialogRef: MatDialogRef<DialogConfirmPricingComponent>
  ) { 
    this.vehicle = data.vehicle;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      price: [this.vehicle.price, Validators.required],
      minSellPrice: [this.vehicle.minSellPrice],
      listPrice: [this.vehicle.listPrice]
    });
  }

  submit(): void {
    this.form.markAllAsTouched();

    if(!this.form.valid){
      return;
    }

    this.loadingUpdatePricing = true;
    const request = this.form.value as UpdateEvalPriceRequest;
    request.priceCent = toPriceCentValue(request.price) ?? undefined;
    request.destination = "SHOWROOM";
    request.id = this.vehicle.id;

    this.evaluationService
      .updatePrice(request)
      .pipe(finalize(() => (
        this.loadingUpdatePricing = false)))
      .subscribe((response: any) => {
        if (response.success) {
          this.toastrService.success("Preço atualizado com sucesso.", null, {
            progressBar: true,
          });
          this.dialogRef.close({ success: true, info: request });
          return;
        }
        this.toastrService.error(
          "Falha ao atualizar o preço. Tente novamente mais tarde.",
          null,
          {
            tapToDismiss: true,
          }
        );
        this.dialogRef.close({ success: false });
      });
    
  }

}
